export default "<%= BUILD_VAR_VIBES_HOST_CHUNK_CSS %>"